

import { useState, useEffect } from "react";
import brand from "assets/images/logo.png";
// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard React examples
import DefaultNavbarLink from "examples/Navbars/DefaultNavbar/DefaultNavbarLink";
import DefaultNavbarMobile from "examples/Navbars/DefaultNavbar/DefaultNavbarMobile";

// Soft UI Dashboard React base styles
import breakpoints from "assets/theme/base/breakpoints";
import { Card } from "@mui/material";

function DefaultNavbar({ transparent, light, action, currentStep }) {
  const [mobileNavbar, setMobileNavbar] = useState(false);
  const [mobileView, setMobileView] = useState(false);

  const openMobileNavbar = ({ currentTarget }) => setMobileNavbar(currentTarget.parentNode);
  const closeMobileNavbar = () => setMobileNavbar(false);

  useEffect(() => {
    // A function that sets the display state for the DefaultNavbarMobile.
    function displayMobileNavbar() {
      if (window.innerWidth < breakpoints.values.lg) {
        setMobileView(true);
        setMobileNavbar(false);
      } else {
        setMobileView(false);
        setMobileNavbar(false);
      }
    }

    /** 
     The event listener that's calling the displayMobileNavbar function when 
     resizing the window.
    */
    window.addEventListener("resize", displayMobileNavbar);

    // Call the displayMobileNavbar function to set the state with the initial value.
    displayMobileNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", displayMobileNavbar);
  }, []);

  return (
    <Container >
      <SoftBox
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <SoftBox
          py={1.5}
          px={{ xs: transparent ? 4 : 5, sm: transparent ? 2 : 5, lg: transparent ? 0 : 5 }}
          mt={4}
          // mx={3}
          width="100%"
          borderRadius="12px"
          shadow={transparent ? "none" : "md"}
          color={light ? "white" : "dark"}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          className="glassmorphism-card"
          zIndex={3}
          sx={({ palette: { transparent: transparentColor, white }, functions: { rgba } }) => ({
            backgroundColor: transparent ? transparentColor.main : rgba(white.main, 0.8),
            backdropFilter: transparent ? "none" : `saturate(200%) blur(30px)`,
          })}
        >
          <SoftBox component={Link}  display="flex" to="/" py={transparent ? 1.5 : 0.75} lineHeight={1}>
            <SoftTypography variant="button" fontWeight="bold" color={light ? "white" : "dark"}>
              <SoftBox display="flex" alignItems="center">
                {brand && <SoftBox component="img" src={brand} alt="Soft UI Logo" width="6rem" />}
              </SoftBox>
            </SoftTypography>

          </SoftBox>
          {/* Progress Line Below Logo */}
          <SoftBox
            mt={1} // Add margin to push it below the logo
            width="100%" // Full width
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <SoftBox>
              <SoftTypography variant="h5" fontWeight="medium">
                Step {currentStep} of 3
              </SoftTypography>
            </SoftBox>

            {Array.from({ length: 3 }).map((_, index) => (
              <SoftBox
                key={index}
                flex={1}
                height="4px"
                mx={0.5}
                mt={10}
                ml={-20}
                bgColor={index < currentStep ? "info" : "light"}
                style={{
                  borderRadius: "4px",
                  transition: "background-color 0.3s ease",
                }}
              />
            ))}
          </SoftBox>
        </SoftBox>
      </SoftBox>
      {mobileView && <DefaultNavbarMobile open={mobileNavbar} close={closeMobileNavbar} />}
    </Container>
  );
}

// Setting default values for the props of DefaultNavbar
DefaultNavbar.defaultProps = {
  transparent: false,
  light: false,
  action: false,
};

// Typechecking props for the DefaultNavbar
DefaultNavbar.propTypes = {
  transparent: PropTypes.bool,
  light: PropTypes.bool,
  action: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      type: PropTypes.oneOf(["external", "internal"]).isRequired,
      route: PropTypes.string.isRequired,
      color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
        "light",
      ]),
      label: PropTypes.string.isRequired,
    }),
  ]),
};

export default DefaultNavbar;
